export default __webpack_public_path__ + "static/media/234.3e9d8002.png";